import threedModel from './3dModel/texts.js';
import actionBar from './ActionBar/texts.js';
import button from './Button/texts.js';
import changelog from './Changelog/texts.js';
import chatbot from './Chatbot/texts.js';
import compare from './Compare/texts.js';
import dateRange from './DateRange/texts.js';
import drawer from './Drawer/texts.js';
import empty from './Empty/text.js';
import errorBoundary from './Error/text.js';
import form from './Form/texts.js';
import layout from './Layout/texts.js';

export default {
  actionBar,
  button,
  changelog,
  chatbot,
  compare,
  dateRange,
  drawer,
  empty,
  errorBoundary,
  form,
  layout,
  threedModel,
};
